import { API_URL } from "../../../config";
import { axios } from "../../../lib/axios";


export const getbundles = async (params:any, partnershipId: string) => {
    return axios.get(`${API_URL}/vfsPhillip/esim-plan`, {params,
        headers: {
          Partnerwebsiteid: partnershipId
        }});
}

export const couponVerify = async (params:any) => {
    return axios.post(`${API_URL}/vfsPhillip/scratch-coupon-verify`, params);
}

export const getCountries = async (params:any, partnershipId: string) => {
    return axios.get(`${API_URL}/regions/countries`, {params,
        headers: {
          Partnerwebsiteid: partnershipId
        }});
}


export const orderCreate = async (params:any) => {
    return axios.post(`${API_URL}/order`, params);
}

export const createCart = async (params:any) => {
    return axios.post(`${API_URL}/carts`, params);
}
